export const StemType = {
  INSTRUMENT: 'instrument',
  DRUMS: 'drums',
  AUDIO: 'audio'
}
